export default {
    playersPreset: [
        {
            title: 'Пчелы',
            color: '#FFEDEE',
            image: require('@/assets/team/010-bee.svg'),
        },
        {
            title: 'Птенчики',
            color: '#FFEDEE',
            image: require('@/assets/team/001-chicken.svg'),
        }, {
            title: 'Челюсти',
            color: '#FFEDEE',
            image: require('@/assets/team/006-shark.svg'),
        }, {
            title: 'Фламинго',
            color: '#FFEDEE',
            image: require('@/assets/team/011-flamingo.svg'),
        }, {
            title: 'Колючки',
            color: '#FFEDEE',
            image: require('@/assets/team/016-hedgehog.svg'),
        }, {
            title: 'Бе-бее',
            color: '#FFEDEE',
            image: require('@/assets/team/002-sheep.svg'),
        }, {
            title: 'Кракен',
            color: '#FFEDEE',
            image: require('@/assets/team/007-octopus.svg'),
        }, {
            title: 'Киты',
            color: '#FFEDEE',
            image: require('@/assets/team/012-whale.svg'),
        }, {
            title: 'Коалы',
            color: '#FFEDEE',
            image: require('@/assets/team/017-koala.svg'),
        }, {
            title: 'Слоны',
            color: '#FFEDEE',
            image: require('@/assets/team/003-elephant.svg'),
        }, {
            title: 'Пингвины',
            color: '#FFEDEE',
            image: require('@/assets/team/008-penguin.svg'),
        }, {
            title: 'Турбо',
            color: '#FFEDEE',
            image: require('@/assets/team/013-snail.svg'),
        }, {
            title: 'Совы',
            color: '#FFEDEE',
            image: require('@/assets/team/004-owl.svg'),
        }, {
            title: 'Клешни',
            color: '#FFEDEE',
            image: require('@/assets/team/009-crab.svg'),
        }, {
            title: 'Клювы',
            color: '#FFEDEE',
            image: require('@/assets/team/014-toucan.svg'),
        }, {
            title: 'Жирафы',
            color: '#FFEDEE',
            image: require('@/assets/team/005-giraffe.svg'),
        },{
            title: 'Бегимотики',
            color: '#FFEDEE',
            image: require('@/assets/team/015-hippopotamus.svg'),
        },
    ],
    chunks: [
        {
            title: 'Общие',
            wordSets: [
                {
                    level: 1,
                    words: [
                        "время",
                        "год",
                        "люди",
                        "путь",
                        "день",
                        "жизнь",
                        "дело",
                        "часть",
                        "число",
                        "Мир",
                        "место",
                        "рука",
                        "школа",
                        "точка",
                        "конец",
                        "штат",
                        "слово",
                        "семья",
                        "факт",
                        "глава",
                        "месяц",
                        "ночь",
                        "глаз",
                        "дом",
                        "сила",
                        "книга",
                        "вода",
                        "форма",
                        "номер",
                        "совет",
                        "рынок",
                        "суд",
                        "идея",
                        "имя",
                        "тело",
                        "линия",
                        "закон",
                        "лицо",
                        "друг",
                        "час",
                        "дверь",
                        "офис",
                        "война",
                        "мама",
                        "срок",
                        "центр",
                        "город",
                        "нужно",
                        "вид",
                        "цена",
                        "курс",
                        "тип",
                        "тема",
                        "отец",
                        "много",
                        "улица",
                        "разум",
                        "банка",
                        "века",
                        "сто",
                        "смысл",
                        "опыт",
                        "язык",
                        "план",
                        "отдел",
                        "утро",
                        "товар",
                        "земля",
                        "нога",
                        "игра",
                        "назад",
                        "союз",
                        "роль",
                        "голос",
                        "сцена",
                        "клуб",
                        "поле",
                        "Счет",
                        "уход",
                        "окно",
                        "жена",
                        "сэр",
                        "налог",
                        "фунт",
                        "метод",
                        "стена",
                        "схема",
                        "сын",
                        "лидер",
                        "фирма",
                        "доска",
                        "доля",
                        "шанс",
                        "цвет",
                        "сайт",
                        "вечер",
                        "цель",
                        "кусок",
                        "Пожар",
                        "сад",
                        "серии",
                        "успех",
                        "думал",
                        "связь",
                        "набор",
                        "шаг",
                        "Море",
                        "игрок",
                        "пара",
                        "выбор",
                        "фильм",
                        "доход",
                        "рост",
                        "леди",
                        "мили",
                        "Вверх",
                        "риск",
                        "округ",
                        "звук",
                        "этаж",
                        "запад",
                        "наука",
                        "стиль",
                        "ответ",
                        "зал",
                        "армия",
                        "брат",
                        "муж",
                        "ножка",
                        "парк",
                        "фонд",
                        "один",
                        "нота",
                        "лето",
                        "дочь",
                        "детка",
                        "река",
                        "мера",
                        "после",
                        "образ",
                        "масло",
                        "атака",
                        "вещь",
                        "рыба",
                        "кровь",
                        "груз",
                        "бар",
                        "текст",
                        "рот",
                        "беда",
                        "опрос",
                        "стул",
                        "вес",
                        "страх",
                        "Скала",
                        "район",
                        "птица",
                        "акции",
                        "обмен",
                        "край",
                        "вызов",
                        "сеть",
                        "матч",
                        "радио",
                        "угол",
                        "гонка",
                        "лес",
                        "Палец",
                        "мяч",
                        "шкала",
                        "кухня",
                        "спорт",
                        "речь",
                        "чай",
                        "отказ",
                        "плечо",
                        "брак",
                        "база",
                        "ферма",
                        "файл",
                        "лига",
                        "копия",
                        "ветер",
                        "нация",
                        "длина",
                        "фронт",
                        "поезд",
                        "боль",
                        "дух",
                        "газ",
                        "вклад",
                        "музей",
                        "агент",
                        "инжир",
                        "видео",
                        "кожа",
                        "вера",
                        "сумка",
                        "вывод",
                        "папа",
                        "зима",
                        "лодка",
                        "вино",
                        "долг",
                        "пакет",
                        "ключ",
                        "судья",
                        "объем",
                        "двор",
                        "фон",
                        "автор",
                        "песня",
                        "гора",
                        "кофе",
                        "тур",
                        "обед",
                        "еда",
                        "мост",
                        "губа",
                        "лист",
                        "ссуда",
                        "принц",
                        "театр",
                        "код",
                        "рейс",
                        "дождь",
                        "актив",
                        "пока",
                        "весна",
                        "завод",
                        "яйцо",
                        "буду",
                        "лента",
                        "адрес",
                        "шея",
                        "дно",
                        "стр",
                        "дитя",
                        "ухо",
                        "волна",
                        "канал",
                        "вести",
                        "грант",
                        "плата",
                        "блок",
                        "гость",
                        "экран",
                        "карта",
                        "фаза",
                        "небо",
                        "сумма",
                        "поиск",
                        "шум",
                        "кошка",
                        "зуб",
                        "уголь",
                        "замок",
                        "течь",
                        "Всего",
                        "релиз",
                        "крыло",
                        "паб",
                        "Озеро",
                        "тон",
                        "круг",
                        "цепь",
                        "Бог",
                        "пункт",
                        "сосед",
                        "масса",
                        "мода",
                        "враг",
                        "слеза",
                        "утюг",
                        "крыша",
                        "билет",
                        "почвы",
                        "пляж",
                        "нос",
                        "бак",
                        "рак",
                        "кость",
                        "живой",
                        "исход",
                        "рельс",
                        "урок",
                        "тень",
                        "шок",
                        "Гол",
                        "трава",
                        "спор",
                        "роман",
                        "метр",
                        "фраза",
                        "вкус",
                        "пилот",
                        "башня",
                        "приз",
                        "ген",
                        "режим",
                        "белок",
                        "Рамка",
                        "Немец",
                        "лед",
                        "порт",
                        "Роза",
                        "босс",
                        "цикл",
                        "грудь",
                        "шляпа",
                        "вход",
                        "осень",
                        "фокус",
                        "спад",
                        "истец",
                        "слой",
                        "душа",
                        "штраф",
                        "сам",
                        "хлеб",
                        "торт",
                        "мясо",
                        "пиво",
                        "пик",
                        "сахар",
                        "дядя",
                        "драма",
                        "зона",
                        "залив",
                        "актер",
                        "чип",
                        "ядро",
                        "честь",
                        "дилер",
                        "смесь",
                        "щека",
                        "танец",
                        "горло",
                        "труба",
                        "темп",
                        "гольф",
                        "песок",
                        "герой",
                        "диск",
                        "ранг",
                        "сдвиг",
                        "ДНК",
                        "гнев",
                        "поток",
                        "нож",
                        "почта",
                        "крем",
                        "ванна",
                        "соль",
                        "Часы",
                        "ради",
                        "тетя",
                        "шутка",
                        "хвост",
                        "семя",
                        "поэт",
                        "моя",
                        "тьма",
                        "Луна",
                        "снег",
                        "запах",
                        "овца",
                        "бремя",
                        "сыр",
                        "миска",
                        "блюдо",
                        "судно",
                        "ткань",
                        "метка",
                        "досуг",
                        "дым",
                        "Стим",
                        "регби",
                        "кино",
                        "лифт",
                        "мышь",
                        "тайна",
                        "класс",
                        "буря",
                        "собор",
                        "яма",
                        "жест",
                        "шапка",
                        "пыли",
                        "полка",
                        "столб",
                        "опера",
                        "штаны",
                        "клерк",
                        "прием",
                        "плоть",
                        "нерв",
                        "учет",
                        "жюри",
                        "синий",
                        "океан",
                        "ручка",
                        "НДС",
                        "крыса",
                        "граф",
                        "скат",
                        "дуть",
                        "стоп",
                        "шелк",
                        "аудит",
                        "гараж",
                        "сюжет",
                        "орган",
                        "зерно",
                        "вред",
                        "поп",
                        "игла",
                        "доза",
                        "пламя",
                        "свая",
                        "рулон",
                        "мэр",
                        "юнец",
                        "трюк",
                        "юмор",
                        "мусор",
                        "забор",
                        "иудей",
                        "смех",
                        "пруд",
                        "эпоха",
                        "ложь",
                        "домен",
                        "такси",
                        "взрыв",
                        "акр",
                        "Бег",
                        "ангел",
                        "лампа",
                        "идти",
                        "тори",
                        "рана",
                        "лев",
                        "жир",
                        "флот",
                        "набег",
                        "белый",
                        "побег",
                        "ритм",
                        "марка",
                        "Фото",
                        "храм",
                        "мотив",
                        "вилла",
                        "миф",
                        "меню",
                        "тепло",
                        "банда",
                        "юбка",
                        "химия",
                        "флаг",
                        "певец",
                        "Пол",
                        "вдова",
                        "утес",
                        "берег",
                        "слух",
                        "док",
                        "вирус",
                        "пятка",
                        "кража",
                        "намек",
                        "грязи",
                        "стих",
                        "сок",
                        "шкаф",
                        "виски",
                        "след",
                        "Форум",
                        "дуб",
                        "позор",
                        "медь",
                        "чек",
                        "утка",
                        "меч",
                        "СПИД",
                        "душ",
                        "бюро",
                        "норма",
                        "грех",
                        "держа",
                        "слава",
                        "лоток",
                        "Тезис",
                        "нести",
                        "охота",
                        "бунт",
                        "Пауза",
                        "сфера",
                        "орел",
                        "плс",
                        "боб",
                        "бонус",
                        "щетка",
                        "пинта",
                        "вор",
                        "бум",
                        "луч",
                        "куст",
                        "дань",
                        "удар",
                        "глина",
                        "тонна",
                        "рог",
                        "сова",
                        "дебют",
                        "эхо",
                        "соус",
                        "элита",
                        "хаос",
                        "рукав",
                        "гроб",
                        "Грейс",
                        "чудо",
                        "атом",
                        "пирог",
                        "злой",
                        "кулак",
                        "свеча",
                        "щит",
                        "ужин",
                        "Дед",
                        "рис",
                        "сарай",
                        "ралли",
                        "резка",
                        "орех",
                        "вена",
                        "свита",
                        "насос",
                        "шансы",
                        "аборт",
                        "горе",
                        "полк",
                        "бегун",
                        "крюк",
                        "пульс",
                        "табак",
                        "опека",
                        "мыло",
                        "магия",
                        "свинг",
                        "горка",
                        "пенни",
                        "язва",
                        "суп",
                        "Quid",
                        "балет",
                        "слон",
                        "торг",
                        "Талия",
                        "кишка",
                        "Можно",
                        "нитка",
                        "салат",
                        "порыв",
                        "бочка",
                        "яхта",
                        "паром",
                        "шоссе",
                        "штырь",
                        "квота",
                        "посол",
                        "бить",
                        "ведро",
                        "шина",
                        "завет",
                        "холст",
                        "лоб",
                        "склад",
                        "марш",
                        "череп",
                        "лук",
                        "Это",
                        "бровь",
                        "племя",
                        "зверь",
                        "жилье",
                        "лимон",
                        "кит",
                        "архив",
                        "лиса",
                        "ясень",
                        "зонд",
                        "тигр",
                        "петля",
                        "сенат",
                        "узел",
                        "сетка",
                        "туман",
                        "озон",
                        "фут",
                        "арка",
                        "вниз",
                        "трон",
                        "туз",
                        "лазер",
                        "отдых",
                        "пуля",
                        "вал",
                        "монах",
                        "пчела",
                        "нить",
                        "болт",
                        "мин",
                        "червь",
                        "тариф",
                        "химик",
                        "хор",
                        "носок",
                        "желчь",
                        "сбор",
                        "змея",
                        "слип",
                        "мпс",
                        "труп",
                        "танцы",
                        "чело",
                        "козел",
                        "сосна",
                        "мех",
                        "вздох",
                        "мешок",
                        "бык",
                        "стой",
                        "эскиз",
                        "волк",
                        "факел",
                        "парад",
                        "пакт",
                        "пряжа",
                        "диван",
                        "кукла",
                        "ребро",
                        "Выход",
                        "барон",
                        "пот",
                        "соло",
                        "порог",
                        "хобот",
                        "шпора",
                        "нюх",
                        "перец",
                        "голод",
                        "воин",
                        "альфа",
                        "пирс",
                        "лобби",
                        "спуск",
                        "домик",
                        "рыбак",
                        "мед",
                        "Телец",
                        "месть",
                        "пони",
                        "мадам",
                        "донор",
                        "мука",
                        "дрель",
                        "стадо",
                        "культ",
                        "эго",
                        "вилка",
                        "ось",
                        "джаз",
                        "тост",
                        "бас",
                        "куча",
                        "паук",
                        "колба",
                        "Наем",
                        "баран",
                        "пасти",
                        "лом",
                        "грязь",
                        "факс",
                        "мрамор",
                        "стирка",
                        "барабан",
                        "плитка",
                        "подвеска",
                        "подпись",
                        "петиция",
                        "дефект",
                        "мудрость",
                        "бабушка",
                        "гостиная",
                        "сегмент",
                        "говядина",
                        "запястье",
                        "мольба",
                        "кусковой",
                        "доброта",
                        "католик",
                        "экстракт",
                        "питьевой",
                        "помидор",
                        "горсть",
                        "солома",
                        "банкир",
                        "лодыжка",
                        "рассвет",
                        "гандикап",
                        "кластер",
                        "академия",
                        "поместье",
                        "совесть",
                        "порошок",
                        "стоянка",
                        "кусочек",
                        "остатки",
                        "туризм",
                        "зрелость",
                        "ритуал",
                        "фракция",
                        "стойло",
                        "дизель",
                        "миграция",
                        "статуя",
                        "танцор",
                        "карандаш",
                        "разряд",
                        "коврик",
                        "лужайка",
                        "диоксид",
                        "перчатка",
                        "бактерия",
                        "протокол",
                        "психолог",
                        "то время",
                        "стебель",
                        "дилемма",
                        "Подруга",
                        "глагол",
                        "гроздь",
                        "километр",
                        "смещение",
                        "дилинг",
                        "рейнджер",
                        "рукопись",
                        "конфуз",
                        "диаметр",
                        "крышка",
                        "вождение",
                        "калитка",
                        "избыток",
                        "памятник",
                        "внутри",
                        "зритель",
                        "от имени",
                        "стюард",
                        "характер",
                        "двойной",
                        "гармония",
                        "хищник",
                        "садовник",
                        "вопреки",
                        "патент",
                        "брошюра",
                        "отчаяние",
                        "ширина",
                        "дружок",
                        "витамин",
                        "актриса",
                        "синдром",
                        "караван",
                        "джинсы",
                        "лосось",
                        "активист",
                        "хвалить",
                        "гравий",
                        "ярость",
                        "раковина",
                        "примерка",
                        "шнурок",
                        "реактор",
                        "стажер",
                        "словарь",
                        "мембрана",
                        "стрельба",
                        "эрозия",
                        "госпожа",
                        "таблетка",
                        "бригада",
                        "карьер",
                        "агрессия",
                        "пух Перо",
                        "массив",
                        "атрибут",
                        "Дракон",
                        "цилиндр",
                        "кальций",
                        "предок",
                        "мораль",
                        "философ",
                        "иллюзия",
                        "бахрома",
                        "маркер",
                        "крупный",
                        "буклет",
                        "посылка",
                        "должник",
                        "рыцарь",
                        "ссыльный",
                        "синтез",
                        "метафора",
                    ]
                },
                {
                    level: 2,
                    words: [
                        "мужчина",
                        "предмет",
                        "ребенок",
                        "Работа",
                        "женщина",
                        "система",
                        "группа",
                        "площадь",
                        "Компания",
                        "проблема",
                        "служба",
                        "партия",
                        "страна",
                        "неделя",
                        "сторона",
                        "бизнес",
                        "вопрос",
                        "процент",
                        "интерес",
                        "развитие",
                        "Деньги",
                        "Другой",
                        "уровень",
                        "машина",
                        "политика",
                        "эффект",
                        "изучение",
                        "доклад",
                        "Дорога",
                        "министр",
                        "ставка",
                        "человек",
                        "причина",
                        "период",
                        "общество",
                        "фигура",
                        "полиция",
                        "контроль",
                        "действие",
                        "девушка",
                        "момент",
                        "возраст",
                        "ценность",
                        "приказ",
                        "здоровье",
                        "решение",
                        "пациент",
                        "церковь",
                        "бумага",
                        "раздел",
                        "Таблица",
                        "смерть",
                        "здание",
                        "команда",
                        "студент",
                        "Миссис",
                        "комитет",
                        "практика",
                        "встреча",
                        "письмо",
                        "мальчик",
                        "питание",
                        "событие",
                        "учитель",
                        "спектр",
                        "сделка",
                        "история",
                        "родитель",
                        "материал",
                        "ситуация",
                        "запись",
                        "проект",
                        "пример",
                        "светлый",
                        "разница",
                        "воздуха",
                        "правило",
                        "работник",
                        "модель",
                        "данные",
                        "природа",
                        "больница",
                        "постель",
                        "движение",
                        "подробно",
                        "свидание",
                        "немного",
                        "награда",
                        "теория",
                        "директор",
                        "к северу",
                        "король",
                        "операция",
                        "господин",
                        "рисунок",
                        "контракт",
                        "тысяча",
                        "источник",
                        "выборы",
                        "будущее",
                        "магазин",
                        "потеря",
                        "животное",
                        "сердце",
                        "стандарт",
                        "выгода",
                        "страница",
                        "Музыка",
                        "волосы",
                        "доктор",
                        "любовь",
                        "фактор",
                        "шаблон",
                        "дизайн",
                        "дерево",
                        "растение",
                        "давление",
                        "знания",
                        "Новости",
                        "основа",
                        "размер",
                        "остаток",
                        "анализ",
                        "область",
                        "список",
                        "внимание",
                        "принцип",
                        "столица",
                        "станция",
                        "деревня",
                        "попытка",
                        "кружка",
                        "усилие",
                        "клетка",
                        "энергия",
                        "лечение",
                        "степень",
                        "задача",
                        "функция",
                        "восток",
                        "оборона",
                        "ресурс",
                        "колледж",
                        "лошадь",
                        "умение",
                        "чувство",
                        "персонаж",
                        "собака",
                        "смотреть",
                        "аргумент",
                        "стакан",
                        "элемент",
                        "Запрос",
                        "заглавие",
                        "аспект",
                        "солнце",
                        "коробка",
                        "клиент",
                        "прибыль",
                        "камень",
                        "деление",
                        "комиссия",
                        "сектор",
                        "сиденье",
                        "болезнь",
                        "техника",
                        "кампания",
                        "версия",
                        "ученик",
                        "продажи",
                        "Память",
                        "культура",
                        "остров",
                        "оратор",
                        "доступ",
                        "звезда",
                        "оплата",
                        "ссылка",
                        "контекст",
                        "второй",
                        "объект",
                        "важность",
                        "открытка",
                        "средства",
                        "сестра",
                        "документ",
                        "поставка",
                        "бюджет",
                        "карьера",
                        "мнение",
                        "четверть",
                        "вариант",
                        "случай",
                        "помощь",
                        "партнер",
                        "читатель",
                        "продажа",
                        "владелец",
                        "правда",
                        "очередь",
                        "приговор",
                        "прошлое",
                        "Начните",
                        "пробный",
                        "газета",
                        "баланс",
                        "филиал",
                        "сомнение",
                        "студия",
                        "контакт",
                        "реформа",
                        "защита",
                        "художник",
                        "мастер",
                        "надежда",
                        "Водитель",
                        "кандидат",
                        "Королева",
                        "скорость",
                        "оценка",
                        "начало",
                        "маршрут",
                        "влияние",
                        "кредит",
                        "прогресс",
                        "реакция",
                        "дорожка",
                        "половина",
                        "цветок",
                        "золото",
                        "зрение",
                        "тюрьма",
                        "писатель",
                        "одежда",
                        "коллега",
                        "боевой",
                        "эксперт",
                        "фермер",
                        "телефон",
                        "образец",
                        "картина",
                        "угроза",
                        "конфликт",
                        "корабль",
                        "напиток",
                        "улыбка",
                        "введение",
                        "кабинет",
                        "манера",
                        "автобус",
                        "строка",
                        "традиция",
                        "футбол",
                        "интервью",
                        "выставка",
                        "описание",
                        "Корпус",
                        "квартира",
                        "сессия",
                        "контраст",
                        "разговор",
                        "кризис",
                        "свобода",
                        "пластина",
                        "журнал",
                        "пенсия",
                        "предел",
                        "молодежь",
                        "победа",
                        "финансы",
                        "Спасибо",
                        "самолет",
                        "отметка",
                        "убийство",
                        "Спальня",
                        "средний",
                        "оружие",
                        "ошибка",
                        "рождение",
                        "бутылка",
                        "критика",
                        "кислота",
                        "модуль",
                        "сборка",
                        "обучение",
                        "поселок",
                        "хранить",
                        "отходы",
                        "стряпчий",
                        "желание",
                        "Погода",
                        "институт",
                        "расход",
                        "тишина",
                        "договор",
                        "капитан",
                        "металл",
                        "поездка",
                        "бассейн",
                        "обложка",
                        "насилие",
                        "ученый",
                        "конгресс",
                        "дисплей",
                        "Ворота",
                        "пистолет",
                        "галерея",
                        "чтение",
                        "акцент",
                        "открытие",
                        "привод",
                        "войска",
                        "солдат",
                        "корона",
                        "членство",
                        "дыхание",
                        "критерий",
                        "кольцо",
                        "инцидент",
                        "индекс",
                        "граница",
                        "карман",
                        "долина",
                        "религия",
                        "квадрат",
                        "сюрприз",
                        "фрукты",
                        "ресторан",
                        "миллиард",
                        "ходить",
                        "выстрел",
                        "подарок",
                        "создание",
                        "механизм",
                        "ответчик",
                        "различие",
                        "панель",
                        "молоко",
                        "башмак",
                        "инженер",
                        "служащий",
                        "видение",
                        "дворец",
                        "высота",
                        "расходы",
                        "редактор",
                        "главный",
                        "значение",
                        "топливо",
                        "круглый",
                        "чемпион",
                        "сигнал",
                        "колено",
                        "понятие",
                        "ожидание",
                        "адвокат",
                        "существо",
                        "приход",
                        "пассажир",
                        "корень",
                        "жалоба",
                        "пластик",
                        "инфляция",
                        "разрыв",
                        "завтрак",
                        "платить",
                        "колонка",
                        "красота",
                        "политик",
                        "борьба",
                        "резидент",
                        "лицензия",
                        "зеркало",
                        "лагерь",
                        "валюта",
                        "перемена",
                        "мышление",
                        "участие",
                        "стресс",
                        "Пальто",
                        "мельница",
                        "глубина",
                        "Доставка",
                        "снижение",
                        "реклама",
                        "экономия",
                        "ботинок",
                        "нагрузка",
                        "епископ",
                        "коттедж",
                        "лестница",
                        "экипаж",
                        "экспорт",
                        "привычка",
                        "охрана",
                        "костюм",
                        "пейзаж",
                        "зеленый",
                        "бомбить",
                        "торговый",
                        "покупка",
                        "империя",
                        "акционер",
                        "камера",
                        "критик",
                        "суждение",
                        "мускул",
                        "прибытие",
                        "канцлер",
                        "владение",
                        "обычай",
                        "тренер",
                        "облако",
                        "симптом",
                        "доллар",
                        "личность",
                        "режиссер",
                        "свадьба",
                        "оценить",
                        "Рубашка",
                        "депозит",
                        "сигарета",
                        "Ответить",
                        "парень",
                        "частота",
                        "усиление",
                        "дюжина",
                        "куртка",
                        "секрет",
                        "явление",
                        "мебель",
                        "инвестор",
                        "вещество",
                        "герцог",
                        "рутинный",
                        "яблоко",
                        "турист",
                        "эмоция",
                        "обещание",
                        "оставил",
                        "инфекция",
                        "веселье",
                        "согласие",
                        "гитара",
                        "занавес",
                        "темнота",
                        "пособие",
                        "слушание",
                        "рассказ",
                        "крикет",
                        "кривая",
                        "резерв",
                        "задержка",
                        "аэропорт",
                        "персонал",
                        "хозяин",
                        "издание",
                        "формула",
                        "миссия",
                        "галстук",
                        "везение",
                        "лекция",
                        "желудок",
                        "молитва",
                        "бедность",
                        "символ",
                        "алкоголь",
                        "климат",
                        "барьер",
                        "подача",
                        "каталог",
                        "оператор",
                        "резюме",
                        "интервал",
                        "издатель",
                        "демократ",
                        "историк",
                        "график",
                        "талант",
                        "трубка",
                        "ракушка",
                        "любовник",
                        "тоннель",
                        "поэзия",
                        "замена",
                        "оборот",
                        "зарплата",
                        "провод",
                        "горшок",
                        "падение",
                        "торговец",
                        "единство",
                        "дизайнер",
                        "детство",
                        "комфорт",
                        "ванная",
                        "участник",
                        "коридор",
                        "профиль",
                        "сложный",
                        "теннис",
                        "кирпич",
                        "поправка",
                        "овощной",
                        "сержант",
                        "колокол",
                        "беженец",
                        "близнец",
                        "принятие",
                        "гордость",
                        "потолок",
                        "слабость",
                        "детектив",
                        "волнение",
                        "красный",
                        "переход",
                        "дефицит",
                        "регистр",
                        "радость",
                        "местный",
                        "черный",
                        "ремень",
                        "концерт",
                        "альбом",
                        "ремонт",
                        "взгляд",
                        "страсть",
                        "скамейка",
                        "стоять",
                        "сознание",
                        "монета",
                        "запрет",
                        "корова",
                        "коалиция",
                        "ужастик",
                        "опекун",
                        "младенец",
                        "кнопка",
                        "дневник",
                        "аренда",
                        "чартер",
                        "формат",
                        "ремесло",
                        "закрытие",
                        "курица",
                        "портрет",
                        "принтер",
                        "эволюция",
                        "углерод",
                        "пластырь",
                        "свинья",
                        "кролик",
                        "фургон",
                        "царство",
                        "холодный",
                        "хорошо",
                        "похороны",
                        "соперник",
                        "дивиденд",
                        "кабель",
                        "приятель",
                        "машины",
                        "планета",
                        "терраса",
                        "командир",
                        "дружба",
                        "союзник",
                        "каретка",
                        "отставка",
                        "шоколад",
                        "симпатия",
                        "скидка",
                        "продавец",
                        "бензин",
                        "полоса",
                        "гарантия",
                        "частица",
                        "любимый",
                        "средство",
                        "амбиция",
                        "стимул",
                        "логика",
                        "волокно",
                        "дорогой",
                        "осмотр",
                        "судьба",
                        "удаление",
                        "гипотеза",
                        "расчет",
                        "часовня",
                        "коллапс",
                        "хлопок",
                        "авария",
                        "молекула",
                        "фрагмент",
                        "покрытие",
                        "капитал",
                        "клиника",
                        "Комплект",
                        "интерьер",
                        "на виду",
                        "статут",
                        "сервер",
                        "веревка",
                        "шахтер",
                        "нехватка",
                        "восторг",
                        "слияние",
                        "полемика",
                        "пустыня",
                        "эпизод",
                        "Кристиан",
                        "колония",
                        "шестерня",
                        "питомник",
                        "пианино",
                        "библия",
                        "турнир",
                        "терапия",
                        "кристалл",
                        "рукоятка",
                        "игрушка",
                        "бунтарь",
                        "насыпной",
                        "туалет",
                        "графика",
                        "призрак",
                        "учение",
                        "посадка",
                        "ездить",
                        "обогрев",
                        "трагедия",
                        "листовка",
                        "запуск",
                        "гавань",
                        "легкость",
                        "гвоздь",
                        "дьявол",
                        "контур",
                        "гибкость",
                        "иерархия",
                        "наследие",
                        "фильтр",
                        "преемник",
                        "кредитор",
                        "сущность",
                        "триумф",
                        "счетчик",
                        "инсульт",
                        "семинар",
                        "Ублюдок",
                        "премия",
                        "поцелуй",
                        "репортер",
                        "Пальма",
                        "кислород",
                        "жидкость",
                        "мужество",
                        "ракета",
                        "дурачить",
                        "аналитик",
                        "делегат",
                        "проспект",
                        "заслуга",
                        "ощущение",
                        "дерьмо",
                        "полночь",
                        "могила",
                        "изоляция",
                        "фантазия",
                        "позиция",
                        "стержень",
                        "трещина",
                        "физика",
                        "диалог",
                        "музыкант",
                        "сэндвич",
                        "защитник",
                        "убийца",
                        "конверт",
                        "субсидия",
                        "мостовая",
                        "тактика",
                        "корзина",
                        "горизонт",
                        "организм",
                        "шерсть",
                        "гнездо",
                        "легкое",
                        "инстинкт",
                        "трейдер",
                        "плавание",
                        "паника",
                        "мелодия",
                        "скандал",
                        "аудитор",
                        "жалость",
                        "фотограф",
                        "помолвка",
                        "перевод",
                        "наездник",
                        "челюсть",
                        "аромат",
                        "ударник",
                        "печень",
                        "ловушка",
                        "параметр",
                        "сиделка",
                        "конкурс",
                        "рейтинг",
                        "точность",
                        "спасение",
                        "надзор",
                        "счастье",
                        "монстр",
                        "оркестр",
                        "сходство",
                        "одеяло",
                        "Терминал",
                        "матрица",
                        "ударил",
                        "хребет",
                        "прогноз",
                        "бронза",
                        "мемориал",
                        "рабыня",
                        "колода",
                        "хирург",
                        "легенда",
                        "плакат",
                        "лопасть",
                        "террор",
                        "текущий",
                        "медаль",
                        "гладкий",
                        "гигант",
                        "житель",
                        "стерлинг",
                        "стрела",
                        "воротник",
                        "печенье",
                        "локоть",
                        "санкция",
                        "пещера",
                        "хижина",
                        "стежок",
                        "вещания",
                        "опухоль",
                        "вердикт",
                        "дельфин",
                        "русский",
                        "нажмите",
                        "скрипт",
                        "трофей",
                        "ягненок",
                        "латунь",
                        "святой",
                        "экзамен",
                        "утилита",
                        "добыча",
                        "укрытие",
                        "фитнес",
                        "электрон",
                        "палатка",
                        "комедия",
                        "антитело",
                        "вертолет",
                        "фермент",
                        "зрелище",
                        "кукуруза",
                        "водород",
                        "телега",
                        "апология",
                        "мозаика",
                        "курение",
                        "спонсор",
                        "терпение",
                        "уборка",
                        "невеста",
                        "текстура",
                        "усмешка",
                        "телеграф",
                        "перепись",
                        "вспышка",
                        "механик",
                        "паруса",
                        "пилюля",
                        "матрос",
                        "задний",
                        "милость",
                        "клапан",
                        "полимер",
                        "молоток",
                        "отмена",
                        "заговор",
                        "теология",
                        "напротив",
                        "подписка",
                        "импульс",
                        "цитата",
                        "балкон",
                        "пригород",
                        "бабочка",
                        "проблеск",
                        "подушка",
                        "патруль",
                        "гардероб",
                        "заложник",
                        "роскошь",
                        "ученость",
                        "близко",
                        "аналогия",
                        "одевание",
                        "романс",
                        "пудинг",
                        "расизм",
                        ]
                },
                {
                    level: 3,
                    words: [
                        "правительство",
                        "жилой дом",
                        "Информация",
                        "изменение",
                        "результат",
                        "использование",
                        "правильно",
                        "сообщество",
                        "Стоимость",
                        "должность",
                        "образование",
                        "исследование",
                        "программа",
                        "промышленность",
                        "учебный класс",
                        "состояние",
                        "деятельность",
                        "сотрудники",
                        "управление",
                        "доказательство",
                        "подготовка",
                        "Университет",
                        "отношения",
                        "качественный",
                        "сотрудник",
                        "структура",
                        "компьютер",
                        "подходить",
                        "количество",
                        "президент",
                        "имущество",
                        "применение",
                        "Секретарь",
                        "производство",
                        "возможность",
                        "соглашение",
                        "безопасность",
                        "Население",
                        "представление",
                        "заявление",
                        "пространство",
                        "труд, работа",
                        "требование",
                        "Гостиница",
                        "ассоциация",
                        "организация",
                        "технологии",
                        "трудность",
                        "обеспечение",
                        "поведение",
                        "пользователь",
                        "инвестиции",
                        "экономика",
                        "обязанность",
                        "время года",
                        "беспокойство",
                        "увеличение",
                        "обсуждение",
                        "председатель",
                        "учреждение",
                        "конференция",
                        "процедура",
                        "предложение",
                        "обстоятельство",
                        "направление",
                        "отношение",
                        "занятость",
                        "обращение",
                        "способность",
                        "библиотека",
                        "посещение",
                        "поверхность",
                        "преимущество",
                        "разнообразие",
                        "возвращение",
                        "телевидение",
                        "большинство",
                        "соревнование",
                        "парламент",
                        "коллекция",
                        "планирование",
                        "общественности",
                        "агентство",
                        "наносить ущерб",
                        "оппозиция",
                        "концепция",
                        "договоренность",
                        "отсутствие",
                        "оборудование",
                        "преступление",
                        "сообщение",
                        "после полудня",
                        "рассмотрение",
                        "стратегия",
                        "рождество",
                        "возвышенность",
                        "выражение",
                        "положение дел",
                        "официальный",
                        "прочность",
                        "транспорт",
                        "английский",
                        "присутствие",
                        "упражнение",
                        "следствие",
                        "понимание",
                        "Опасность",
                        "расстояние",
                        "комментарий",
                        "содержание",
                        "справедливость",
                        "реальность",
                        "выходные дни",
                        "работодатель",
                        "отверстие",
                        "страхование",
                        "уверенность",
                        "поколение",
                        "посетитель",
                        "обязательство",
                        "двигатель",
                        "администрация",
                        "потерпевший",
                        "расследование",
                        "облегчение",
                        "регулирование",
                        "категория",
                        "потребитель",
                        "строительство",
                        "джентльмен",
                        "улучшение",
                        "существование",
                        "появление",
                        "дисциплина",
                        "распределение",
                        "представитель",
                        "безработица",
                        "объяснение",
                        "вместимость",
                        "намерение",
                        "экспертиза",
                        "десятилетие",
                        "уведомление",
                        "определение",
                        "сокращение",
                        "запустить",
                        "концентрация",
                        "предприятие",
                        "перечислить",
                        "инструкция",
                        "удовольствие",
                        "температура",
                        "признание",
                        "республика",
                        "фотография",
                        "головной мозг",
                        "публикация",
                        "медсестра",
                        "руководство",
                        "эксперимент",
                        "толпа людей",
                        "соединение",
                        "предположение",
                        "учебный план",
                        "инициатива",
                        "министерство",
                        "инструмент",
                        "расположение",
                        "профессор",
                        "интерпретация",
                        "сочетание",
                        "перспектива",
                        "приоритет",
                        "орудие труда",
                        "полоса дороги",
                        "литература",
                        "альтернатива",
                        "победитель",
                        "прохождение",
                        "характеристика",
                        "устройство",
                        "специалист",
                        "заместитель",
                        "наблюдение",
                        "забастовка",
                        "маркетинг",
                        "впечатление",
                        "побережье",
                        "атмосфера",
                        "революция",
                        "чемпионат",
                        "Переговоры",
                        "благосостояние",
                        "поклонник",
                        "продвижение",
                        "потенциал",
                        "происхождения",
                        "тенденция",
                        "генеральный",
                        "предупреждение",
                        "гражданин",
                        "условность",
                        "заключенный",
                        "достижение",
                        "сравнение",
                        "демократия",
                        "за работой",
                        "рацион питания",
                        "производитель",
                        "территория",
                        "сенсорный",
                        "арендатор",
                        "член совета",
                        "корпорация",
                        "независимость",
                        "обнаружение",
                        "база данных",
                        "сторонник",
                        "проживание",
                        "исключение",
                        "идентичность",
                        "покупатель",
                        "напряженность",
                        "меньшинство",
                        "предпосылка",
                        "расширение",
                        "конституции",
                        "партнерство",
                        "загрязнение",
                        "рулевое колесо",
                        "женский пол",
                        "держатель",
                        "стихотворение",
                        "утверждение",
                        "установка",
                        "губернатор",
                        "поддержание",
                        "акция протеста",
                        "ограничение",
                        "профессия",
                        "финансирование",
                        "рекомендация",
                        "репутации",
                        "голосование",
                        "восстановление",
                        "Серебряный",
                        "инспектор",
                        "богатство",
                        "презентация",
                        "электричество",
                        "сопротивление",
                        "перспективы",
                        "эффективность",
                        "лаборатория",
                        "срок жизни",
                        "сертификат",
                        "философия",
                        "настроение",
                        "переменная",
                        "соотношение",
                        "окончательный",
                        "Исследователь",
                        "вмешательство",
                        "квалификация",
                        "арендная плата",
                        "относительный",
                        "осознание",
                        "фестиваль",
                        "интеллект",
                        "сотрудничество",
                        "уравнение",
                        "арендодатель",
                        "уход на пенсию",
                        "нарушение",
                        "день рождения",
                        "лекарство",
                        "разрешение",
                        "взаимодействие",
                        "свидетель",
                        "Платформа",
                        "полицейский",
                        "провинция",
                        "крестьянский",
                        "восприятие",
                        "поражение",
                        "получение",
                        "демонстрация",
                        "химическая",
                        "консультант",
                        "священник",
                        "потребление",
                        "журналист",
                        "мастерская",
                        "компенсация",
                        "статистика",
                        "ловля рыбы",
                        "выживание",
                        "род занятий",
                        "тревожность",
                        "замечание",
                        "поставщик",
                        "предпочтение",
                        "индикация",
                        "Подсказка",
                        "наблюдатель",
                        "противник",
                        "измерение",
                        "операционная",
                        "консервативный",
                        "принцесса",
                        "энтузиазм",
                        "реализация",
                        "архитектура",
                        "обработка",
                        "место хранения",
                        "удовлетворение",
                        "консультация",
                        "напряжение",
                        "чек об оплате",
                        "магистрат",
                        "убеждение",
                        "постоянный",
                        "воображение",
                        "одолжение",
                        "объявление",
                        "сочинение",
                        "архитектор",
                        "вселенная",
                        "ассистент",
                        "казначейство",
                        "психология",
                        "диаграмма",
                        "подопечный",
                        "возражение",
                        "директива",
                        "нападение",
                        "лесоматериалы",
                        "добродетель",
                        "покрасить",
                        "грамматика",
                        "привилегия",
                        "сохранение",
                        "публичность",
                        "завершение",
                        "картофель",
                        "отражение",
                        "наказание",
                        "повестка дня",
                        "компаньон",
                        "путешественник",
                        "доброволец",
                        "идеология",
                        "расстройство",
                        "инновация",
                        "заявитель",
                        "интеграция",
                        "проходить",
                        "приобретатель",
                        "преобразование",
                        "император",
                        "Регистрация",
                        "депрессия",
                        "разрушение",
                        "уполномоченный",
                        "оправдание",
                        "декларация",
                        "корреспондент",
                        "чужой человек",
                        "смертность",
                        "приглашение",
                        "минеральная",
                        "интерфейс",
                        "федерация",
                        "велосипед",
                        "подозрение",
                        "избиратель",
                        "сложность",
                        "констебль",
                        "конкурент",
                        "эквивалент",
                        "кинотеатр",
                        "островной",
                        "бухгалтер",
                        "инвалидность",
                        "церемония",
                        "процессор",
                        "спутниковое",
                        "стабильность",
                        "издательский",
                        "иллюстрация",
                        "посмотреть",
                        "Годовщина",
                        "монополия",
                        "юрисдикция",
                        "насекомое",
                        "регулировка",
                        "минимальный",
                        "празднование",
                        "фантастика",
                        "Спецификация",
                        "излучение",
                        "вторжение",
                        "аккумулятор",
                        "беспорядок",
                        "необходимость",
                        "переключатель",
                        "приключение",
                        "дискриминация",
                        "недостаток",
                        "единообразный",
                        "лояльность",
                        "полковник",
                        "живая природа",
                        "изнасилование",
                        "авиакомпания",
                        "тестирование",
                        "аббатство",
                        "шампанское",
                        "посещаемость",
                        "получатель",
                        "математика",
                        "социология",
                        "пенсионер",
                        "бизнесмен",
                        "показатель",
                        "вероятность",
                        "разделение",
                        "капитализм",
                        "портфолио",
                        "разработчик",
                        "континент",
                        "доступность",
                        "вычисления",
                        "обоснование",
                        "выпускной",
                        "перевозчик",
                        "разведение",
                        "строитель",
                        "классификация",
                        "самоубийство",
                        "правопреемство",
                        "мошенничество",
                        "плотность",
                        "компромисс",
                        "дверной проем",
                        "приложение",
                        "скульптура",
                        "спекуляция",
                        "резиденция",
                        "рецепт блюда",
                        "модификация",
                        "заголовок",
                        "тазобедренный",
                        "политехникум",
                        "диагностика",
                        "разводить",
                        "коллектор",
                        "скорая помощь",
                        "синхронизация",
                        "ингредиент",
                        "царствование",
                        "делегация",
                        "автономия",
                        "консенсус",
                        "беременность",
                        "концессия",
                        "освобождение",
                        "репетитор",
                        "подросток",
                        "орфографии",
                        "чувство вины",
                        "переворот",
                        "кошмарный сон",
                        "Пасхальный",
                        "мотивация",
                        "христианство",
                        "избыточность",
                        "назначение",
                        "содружество",
                        "корреляция",
                        "освещение",
                        "интенсивность",
                        "учредительный",
                        "конечность",
                        "истребитель",
                        "организатор",
                        "разочарование",
                        "что касается",
                        "место встречи",
                        "гулять пешком",
                        "идеальный",
                        "бриллиант",
                        "враждебность",
                        "помилование",
                        "актуальность",
                        "опросный лист",
                        "архиепископ",
                        "окрестности",
                        "республиканец",
                        "выполнение",
                        "социализм",
                        "мониторинг",
                        "максимальная",
                        "факультет",
                        "равновесие",
                        "оранжевый",
                        "география",
                        "увольнение",
                        "подбородок",
                        "бред какой то",
                        "преследование",
                        "бронирование",
                        "обеденный",
                        "преступник",
                        "упоминание",
                        "компетентность",
                        "досягаемость",
                        "хранитель",
                        "предшественник",
                        "супермаркет",
                        "привязанность",
                        "девственница",
                        "коммерция",
                        "выдвижной ящик",
                        "экономист",
                        "подрядчик",
                        "классический",
                        "наводнение",
                        "контейнер",
                        "основатель",
                        "переписка",
                        "правитель",
                        "греческий",
                        "живая изгородь",
                        "протяжение",
                        "духовой шкаф",
                        "предубеждение",
                        "переменный ток",
                        "равенство",
                        "референдум",
                        "циркуляция",
                        "посольство",
                        "террорист",
                        "профилактика",
                        "Европейская",
                        "определенность",
                        "рабочий стол",
                        "очарование",
                        "бюрократия",
                        "Сковорода",
                        "причалить",
                        "поощрение",
                        "итальянский",
                        "композитор",
                        "дополнение",
                        "столкновение",
                        "целостность",
                        "противоречие",
                        "электроника",
                        "поколения",
                        "администратор",
                        "сдержанность",
                        "экспедиция",
                        "мобильность",
                        "позвоночник",
                        "неравенство",
                        "две недели",
                        "коррупция",
                        "эскадрилья",
                        "интерференция",
                        "сокровище",
                        "изготовление",
                        "ископаемое",
                        "страдания",
                        "преподаватель",
                        "автомагистраль",
                        "место обитания",
                        "совместный",
                        "вдохновение",
                        "сексуальность",
                        "большой палец",
                        "препятствие",
                        "параллельно",
                        "торговая точка",
                        "библиотекарь",
                        "впрыскивание",
                        "непрерывность",
                        "украшение",
                        "компакт диск",
                        "пересмотр",
                        "Стиль жизни",
                        "вхождение",
                        "поклонение",
                        "духовенство",
                        "комментатор",
                        "наследник",
                        "популярность",
                        "индийский",
                        "составить",
                        "евангелие",
                        "пожертвование",
                        "приватизация",
                        "страдалец",
                        "конфигурация",
                        "страдание",
                        "осторожность",
                        "сыворотка",
                        "сверстников",
                        "футбольный",
                        "заимствование",
                        "светлость",
                        "аутсайдер",
                        "достоинство",
                        "календарь",
                        "изобретение",
                        "Солнечный свет",
                        "эксплуатация",
                        "произнесение",
                        "соблюдение",
                        "коммунист",
                        "Обратная связь",
                        "салон самолета",
                        "текстильный",
                        "юго-восток",
                        "зависимость",
                        "презрение",
                        "небрежность",
                        "господствующий",
                        "промоутер",
                        "стремление",
                        "наследование",
                        "завещание",
                        "партизанский",
                        "лейтмотив",
                        "напоминание",
                        "летучая мышь",
                        "искушение",
                        "старший мастер",
                        "иностранец",
                        "морской узел",
                        "возрождение",
                        "окружение",
                        "остроумие",
                        "спонсорство",
                        "последователь",
                        "контроллер",
                        "направления",
                        "человечество",
                        "конфронтация",
                        "сила тяжести",
                        "подозреваемый",
                        "самописец",
                        "конгрегация",
                        "крепление",
                        "раскрытие",
                        "скрещивание",
                        "подотчетность",
                        "бодрствование",
                        "фертильность",
                        "включение",
                        "суверенитет",
                        "поддержка",
                        "млекопитающее",
                        "любопытство",
                        "документация",
                        "планировщик",
                        "усложнение",
                        "известность",
                        "ориентация",
                        "реконструкция",
                        "покровитель",
                        "готовность",
                        "подтверждение",
                        "локомотив",
                        "группировка",
                        "очиститель",
                        "президентство",
                        "прецедент",
                        "горничная",
                        "феминистка",
                        "геодезист",
                        "разногласие",
                        "Головная боль",
                        "точка зрения",
                        "Вице-президент",
                        "гениальность",
                        "обвинение",
                        "пропаганда",
                        "неистовство",
                        "клавиатура",
                        "невежество",
                        "член профсоюза",
                        "приспособление",
                        "погашение",
                        "подушечка",
                        "электорат",
                        "землевладелец",
                        "процветание",
                        "размещение",
                        "солидарность",
                        "снаряжение",
                        "перфоратор",
                        "слушатель",
                        "учтивость",
                        "крайний срок",
                        "неспособность",
                        "господство",
                        "руководитель",
                        "уцелевший",
                        "бомбардировщик",
                        "окончание",
                        "формулировка",
                        "исполнитель",
                        "англичанин",
                        "безрассудство",
                        "постановление",
                        "банкротство",
                        "резервуар",
                        "мэйнфреймов",
                        "либеральный",
                        "уборка урожая",
                        "чувство обиды",
                        "следователь",
                        "иммиграция",
                        "отступление",
                        "разорение",
                        "обновление",
                        "бомбардировка",
                        "меморандум",
                        "ненависть",
                        "надзиратель",
                        "методология",
                        "продолжить",
                        "поместиться",
                        "неприятность",
                        "треугольник",
                        "мочевой пузырь",
                        "дневной свет",
                        "развлечение",
                        "репетиция",
                        "захоронение",
                        "холодильник",
                        "подшипник",
                        "наслаждение",
                        "военное время",
                        "нежелание",
                        "советский",
                        "растительность",
                        "полусфера",
                        "энтузиаст",
                        "лейтенант",
                        "экстремальный",
                        "национализм",
                        "полуфинал",
                        "инфраструктура",
                        "биография",
                        "националист",
                        "северо-Запад",
                        "коралловый",
                        "первичный",
                        "рассуждения",
                        "Национальность",
                        "современный",
                        "домохозяйка",
                        "написание",
                        "боевой дух",
                        "обезьяна",
                        "кассета",
                        "ясность",
                        "отстой",
                        "проекция",
                        "блокнот",
                        "маклер",
                        "биология",
                        "бункер",
                        "экспресс",
                        "теплица",
                        "тормоз",
                        "варрант",
                        "джунгли",
                        "инсайдер",
                        "монитор",
                        "аппетит",
                        "винтовка",
                        "пришелец",
                        "Японский",
                        "материк",
                        "убежище",
                        "дефолт",
                        "алюминий",
                        "рецепт",
                        "агония",
                        "радуга",
                        "котелок",
                        "Вязание",
                        "баллон",
                        "скобка",
                        "монархия",
                        "варенье",
                        "ожидания",
                        "отлично",
                        "Ирония",
                        "гильдия",
                        "аккорд",
                        "грузовой",
                        "молочный",
                        "шиллинг",
                        "Футболка",
                        "величина",
                        "стадион",
                        "старший",
                        "Официант",
                        "муравей",
                        "пшеница",
                        "монарх",
                        ]
                },
            ]
        },
        {
            title: 'Персонажи',
            wordSets: [
                {
                    level: 1,
                    words: [
                        "Супермен",
                        "Бэтмен",
                        "Человек-паук",
                        "Росомаха",
                        "Чудо-женщина",
                        "Капитан Америка",
                        "Зелёный Фонарь",
                        "Флэш ",
                        "Халк",
                        "Сорвиголова",
                        "Робин ",
                        "Железный человек",
                        "Тор",
                        "Женщина-кошка",
                        "Профессор Икс",
                        "Рафаэль",
                        "Хеллбой",
                        "Рик Граймс",
                        "Дэдпул",
                        "Робин (Тим Дрейк)",
                        "Ник Фьюри",
                        "Доктор Стрэндж",
                        "Циклоп",
                        "Серебряный Сёрфер",
                        "Чёрная пантера",
                        "Аквамен",
                        "Блэйд",
                        "Человек-муравей ",
                        "Призрачный гонщик",
                        "Магнето",
                        "Джокер",
                        "Алёша Попович",
                        "Баба-яга",
                        "Водяной",
                        "Жар-птица",
                        "Змей Горыныч",
                        "Иван-дурак",
                        "Иван-царевич",
                        "Илья Муромец",
                        "Колобок",
                        "Снегурочка",
                        "Кощей",
                        "Эдне Мод (Суперсемейка)",
                        "Рэндл Макмерфи",
                        "Оптимус Прайм",
                        "Норман Бейтс",
                        "Миньоны",
                    ]
                },
                {
                    level: 2,
                    words: [
                        "Максимус (Гладиатор)",
                        "Леголас",
                        "Уэнздэй Аддамс",
                        "Инспектор Клузо",
                        "Иниго Монтойя (Принцесса-невеста)",
                        "ЭАЛ (Космическая одиссея 2001 года)",
                        "Грут 88. Громит 87. Итан Хант",
                        "Ред (Побег из Шоушенка)",
                        "Уолкер (В упор)",
                        "Дуэйн Хикс (Чужие)",
                        "Вуди (История игрушек)",
                        "Уитнэйл (Уитнэйл и я)",
                        "V (V — значит вендетта)",
                        "Сэмуайз Гэмджи",
                        "Рядовой Уильям Хадсон (Чужие)",
                        "Лисбет Саландер",
                        "Фрэнк Дребин",
                        "Донни Дарко",
                        "Капитан Кирк",
                        "Звездный лорд (Стражи Галактики)",
                        "Тони Монтана",
                        "Мардж Гандерсон (Фарго)",
                        "Нео",
                        "Гарри Поттер",
                        "Голлум / Смеагол",
                        "Ганс Ланда",
                        "Джордж Бейли ",
                        "Инопланетянин (Е.Т.)",
                        "Бильбо Бэггинс",
                        "Доктор Кинг Шульц",
                        "Эйс Вентура",
                        "Сара Коннор",
                        "Китнисс Эвердин",
                        "Джек Бартон",
                        "Аксель Фоули",
                        "Амели Пулен",
                        "Вито Корлеоне",
                        "Шон (Зомби по имени Шон)",
                        "Оби-Ван Кеноби",
                        "Люк Скайуокер",
                        "Гарри Каллахан",
                        "Лестер Бёрнем",
                        "Рик Декард",
                        "Томми ДеВито",
                        "Антон Чигур",
                        "Эми Данн",
                        "Луи Блум",]
                },
                {
                    level: 3,
                    words: [
                        "Кайзер Созе",
                        "Феррис Бьюллер",
                        "Йода",
                        "Водитель (Драйв)",
                        "Уолтер Собчак",
                        "Рокки Бальбоа",
                        "Аттикус Финч",
                        "Джулс Винфилд",
                        "Питер Венкман",
                        "Гэндальф",
                        "Снейк Плискин",
                        "Терминатор Т-8оо",
                        "Форрест Гамп",
                        "Патрик Бейтмен",
                        "Дэниэл Плэйнвью",
                        "Невеста (Убить Билла)",
                        "Трэвис Бикл",
                        "Ганнибал Лектер",
                        "Аладдин (Дисней)",
                        "Вольт (персонаж)",
                        "Гуфи",
                        "Джафар (Дисней)",
                        "Диснеевские принцессы",
                        "Злая королева (Дисней)",
                        "Макс Гуф",
                        "Малефисента",
                        "Медведь Балу (Дисней)",
                        "Микки Маус",
                        "Минни Маус",
                        "Мэйбл Пайнс",
                        "Пиноккио (Дисней)",
                        "Питер Пэн (Дисней)",
                        "Плуто",
                        "Пумба (Король Лев)",
                        "Русалочка Ариэль",
                        "Симба",
                        "Скрудж Макдак",
                        "Сова (Винни-Пух)",
                        "Стервелла Де Виль",
                        "Тимон (Король Лев)",
                        "Чип и Дейл",
                        "Индиана Джонс",
                        "Джеймс Бонд",
                        "Хан Соло",
                        "Дарт Вейдер",
                        "Майкл Корлеоне",
                        "Джек Воробей",
                        "Арагорн",
                        "Локи",
                    ]
                },
            ]
        },
        {
            title: 'It',
            wordSets: [
                {
                    level: 1,
                    words: [
                        "совершенный код",
                        "confluence",
                        "мобильная разработка",
                        "cms",
                        "android",
                        "vue",
                        "ивенты",
                        "typescript",
                        "open source",
                        "котлин",
                        "docker",
                        "php 7.4",
                        "интерфейс",
                        "переменная",
                        "релиз",
                        "intel",
                        "метафора",
                        "yii framework",
                        "npm",
                        "разработка под ios",
                        "разработка",
                        "selenium",
                        "ros",
                        "робототехника",
                        "javascript",
                        "контейнеры",
                        "go",
                        "html5",
                        "express.js",
                        "internet explorer",
                        "персональные данные",
                        "security",
                        "обучение",
                        "навигация",
                        "яндекс",
                        "kubernetes",
                        "yii",
                        "css",
                        "заглушка",
                        "git",
                        "web-разработка",
                        "отладка",
                        "схемотехника",
                        "ссылки",
                        "linux",
                        "jetbrains",
                        "кэширование",
                        "postgresql",
                        "google",
                        "прототипирование",
                        "проектирование",
                        "конференция",
                        "блок",
                        "перечисление",
                        "диаграмма",
                        "уязвимости",
                        "директива",
                        "аккреция",
                        "микросервисы",
                        "w3c",
                        "массив",
                        "печатные платы",
                        "cargo",
                        "virtual reality",
                        "ооп",
                        "unity3d",
                        "vr",
                        "flutter",
                        "O'Reilly",
                        "meetup",
                        "с++",
                        "оптимизация",
                        "conference",
                        "php",
                        "шифрование",
                        "символ",
                        "qa automation",
                        "утверждение",
                        "elasticsearch",
                        "расширения",
                        "data mining",
                        "время связывания",
                        "дарт",
                        "мероприятие",
                        "es6",
                        "nodejs",
                        "дайджест", ]
                },
                {
                    level: 2,
                    words: [
                        "api",
                        "microsoft",
                        "моделирование",
                        "криптография",
                        "математика",
                        "gitlab",
                        "глонасс",
                        "выпуск",
                        "explain",
                        "macos",
                        "symfony",
                        "activerecord",
                        "браузеры",
                        "искусственный интеллект",
                        "тип данных",
                        "devops",
                        "GUI",
                        "клиентская оптимизация",
                        "строка",
                        "IDE",
                        "angular",
                        "функция",
                        "микроконтроллеры",
                        "kotlin",
                        "dartlang",
                        "код",
                        "автоматизация тестирования",
                        "число",
                        "node.js",
                        "исключение",
                        "шаблон",
                        "java",
                        "рефакторинг",
                        "перевод",
                        "метод",
                        "google chrome",
                        "gdb",
                        "framework",
                        "роботы",
                        "ar",
                        "префикс",
                        "мобильные приложения",
                        "процедура",
                        "qa",
                        "android development",
                        "константа",
                        "проект",
                        "events",
                        "электроника",
                        "mysql",
                        "node",
                        "tdd",
                        "debug",
                        "оператор",
                        "аналитика",
                        "программирование",
                        "big data",
                        "assembler",
                        "глобальные данные",
                        "комментарий",
                        "взлом",
                        "объект",
                        "wrike",
                        "c#",
                        "swift",
                        "базы данных",
                        "apple",
                        "индекс",
                        "visual studio",
                        "windows",
                        "теория вероятностей",
                        "python",
                        "стандарты",
                        "dart 2.0",
                        "objective-c",
                        "точка управления",
                        "uefi",
                        "итерация",
                        "информационная безопасность",
                        "алгоритм",
                        "seo",
                        "кибербезопасность",
                        "монетизация",
                        "ip-телефония",
                        "parallels",
                        "криптовалюта",
                        "биткоин",]
                },
                {
                    level: 3,
                    words: [

                        "обработка ошибок",
                        "asterisk",
                        "компьютерное зрение",
                        "облачные сервисы",
                        "литерал",
                        "методология",
                        "bash",
                        "интеграция",
                        "c++",
                        "yii2",
                        "фронтенд",
                        "ssl",
                        "поиск",
                        "blockchain",
                        "форматирование",
                        "gamedev",
                        "атрибут",
                        "laravel",
                        "логические выражения",
                        "статистика",
                        "react",
                        "дополненная реальность",
                        "цикл",
                        "performance",
                        "http",
                        "указатель",
                        "требование",
                        "инкапсуляция",
                        "sql",
                        "блокчейн",
                        "unreal engine 4",
                        "github",
                        "golang",
                        "алгоритмы",
                        "стартапы",
                        "модель",
                        "nosql",
                        "блогосфера",
                        "структура",
                        "тестирование",
                        "opera",
                        ".net",
                        "postgres",
                        "уязвимость",
                        "html",
                        "dba",
                        "dart",
                        "reactos",
                        "ios",
                        "highload",
                        "python3",
                        "oracle",
                        "иерархия",
                        "gps",
                        "bitcoin",
                        "хакатон",
                        "jira",
                        "конструирование",
                        "chrome extension",
                        "паттерны проектирования",
                        "анализ данных",
                        "ruby on rails",
                        "митапы",
                        "ios development",
                        "rust",
                        "webpack",
                        "ключевое слово",
                        "конференции",
                        "xcode",
                        "субд",
                        "mssql",
                        "машинное обучение",
                        "нейросети",
                        "абстракция",
                        "разработка приложений",
                        "класс",
                        "ios разработка",
                        "архитектура",
                        "телефония",
                        "ардуино",
                        "hadoop",
                        "saas сервисы",
                        "UML",
                        "testing",
                        "mozilla",
                        "виртуальная реальность",
                        "тип проекта",]
                },
            ]
        },
        {
            title: 'Все для дома',
            wordSets: [
                {
                    level: 1,
                    words: [
                        "Горшок",
                        "Массажер",
                        "Факс",
                        "Термопот",
                        "Хлебница",
                        "Кабель",
                        "Аэратор",
                        "Тостер",
                        "Портмоне",
                        "Припой",
                        "Фильмы",
                        "Термощуп",
                        "Матрац",
                        "Плеер",
                        "Мотоблок",
                        "Ванночка",
                        "Фен",
                        "Фонарь",
                        "PH метр",
                        "Кукла",
                        "Терка",
                        "Бленда",
                        "Ремень",
                        "Пылесос",
                        "Нейлер",
                        "Привод",
                        "Шезлонг",
                        "Трубки",
                        "Омметр",
                        "Эхолот",
                        "Столик",
                        "Фитинг",
                        "Домкрат",
                        "Манеж",
                        "Лупа",
                        "Тонер",
                        "Штопор",
                        "Бур",
                        "Верстак",
                        "Каска",
                        "Руль",
                        "Смартфон",
                        "Гирлянда",
                        "Объектив",
                        "Шумовка",
                        "Домофон",
                        "Пакеты",
                        "Скалка",
                        "Тонометр",
                        "Миксер",
                        "Штатив",
                        "Твитер",
                        "Дисплей",
                        "Блинница",
                        "Бензобур",
                        "Тахометр",
                        "Биде",
                        "Моддинг",
                        "Термос",
                        "Фигурка",
                        "Тиски",
                        "Проектор",
                        "Колонки",
                        "Безмен",
                        "Антенна",
                        "Стилус",
                        "Мышь",
                        "Масломер",
                        "GPS-маяк",
                        "Сифон",
                        "Эпилятор",
                        "Чайник",
                        "Сканер",
                        "Бензорез",
                        "Ноутбук",
                        "Поиск",
                        "Насос",
                        "Кабель",
                        "Венчик",
                        "Слинг",
                        "Дуршлаг",
                        "Дровокол",
                        "Ходунки",
                        "Вытяжка",
                        "Кусторез",
                        "USB хаб",
                        "LEGO",
                        "Планшет",
                        "Кофе",
                        "Часы",
                        "Резак",
                        "Рулетка",
                        "Клей",
                        "3D Ручка",
                        "Ковш",
                        "Корпус",
                        "Экран",
                        "Чернила",
                        "Утюг",
                        "Моноблок",
                        "Дрель",
                        "Дисковод",
                        "Су-вид",
                        "Пирометр",
                        "Стусло",
                        "Смазка",
                        "Брелок",
                        "Микрофон",
                        "Манометр",
                        "Пазл",
                        "Фрезер",
                        "Монитор",
                        "Оверлоки",
                        "Сервер",
                        "Рубанок",
                        "Скобы",
                        "Шланг",
                        "Масленка",
                        "Точило",
                        "Гриль",
                        "Телескоп",
                        "Диктофон",
                        "Расческа",
                        "Турка",
                        "Водоблок",
                        "Лопатка",
                        "ИБП",
                        "Жаровня",
                        "Топор",
                        "Коврик",
                        "Люксметр",
                        "АТС",
                        "Кастрюля",

                    ]
                },
                {
                    level: 2,
                    words: [
                        "IP-камера",
                        "Штроборез",
                        "Анемометр",
                        "Резервуар",
                        "Клавиатура",
                        "Френч-пресс",
                        "Видеокамера",
                        "Кард-ридер",
                        "Светомузыка",
                        "Пневмодрель",
                        "3D-сканер",
                        "Холодильник",
                        "Мультиварка",
                        "Термобумага",
                        "Коммутатор",
                        "Поддержка",
                        "Кипятильник",
                        "Экшн-камера",
                        "Фотофильтр",
                        "Телевизор",
                        "Перфоратор",
                        "Кофемолка",
                        "Ирригаторы",
                        "Автоколонка",
                        "Тепловизор",
                        "Софтбоксы",
                        "Конвертеры",
                        "Молокоотсос",
                        "Док Станции",
                        "Веб-камера",
                        "ТВ антенна",
                        "Очки AR, VR",
                        "Респиратор",
                        "Внешний HDD",
                        "Видеокабель",
                        "Мороженица",
                        "Батарейка",
                        "Мультитул",
                        "Чай-машина",
                        "Фритюрница",
                        "3D Принтер",
                        "Яйцерезка",
                        "Прихватка",
                        "Шлифлисты",
                        "Модем 3G/4G",
                        "Калькулятор",
                        "Контроллер",
                        "Прожектор",
                        "Открывалка",
                        "Платформа",
                        "Мясорубка",
                        "Йогуртница",
                        "AV-ресивер",
                        "Овощечистка",
                        "Перечница",
                        "VR Станция",
                        "Термоклей",
                        "Фотозонты",
                        "Ломтерезка",
                        "Синтезатор",
                        "Толщиномер",
                        "Светильник",
                        "Дистиллятор",
                        "Фотобоксы",
                        "Видеокарта",
                        "Дым машина",
                        "Док Станции",
                        "Винный шкаф",
                        "Зажим массы",
                        "Ножеточка",
                        "Наборы д/т",
                        "Брошюровщик",
                        "Набор фрез",
                        "Модем xDSL",
                        "Лапшерезка",
                        "Витая пара",
                        "Конвектор",
                        "Алкотестер",
                        "Фоторамка",
                        "Хлебопечь",
                        "Электропечь",
                        "Конструктор",
                        "Пароварка",
                        "Склерометр",
                        "Попкорница",
                        "Плиткорез",
                        "Патч-панель",
                        "Процессор",
                        "Мотопомпа",
                        "Яйцеварка",
                        "Книга по ИТ",
                        "Фен-щетка",
                        "Струбцина",
                        "Автоантенна",
                        "Фотобарабан",
                        "Виброплита",
                        "Конденсатор",
                        "Реноватор",
                        "Микроскопы",
                        "Подушка д/т",
                        "Автосувенир",
                        "Мультиметр",
                        "Сковорода",
                        "Диспенсер",
                        "Магнитола",
                        "Шлюз VoIP",
                        "Радионяня",
                        "Минимойка",
                        "Термопленка",
                        "Видеоигра",
                        "Ламинатор",
                        "Компрессор",
                        "Ингалятор",
                        "Культиватор",
                        "Гайковерт",
                        "Фото пленка",
                        "Аэрогриль",
                    ]
                },
                {
                    level: 3,
                    words: [
                        "Водоочиститель",
                        "Сетевой фильтр",
                        "Карта оплаты",
                        "Отпариватель",
                        "Сплиттер ADSL",
                        "Весы напольные",
                        "Коврик в салон",
                        "Фильтр салона",
                        "Помпа для СВО",
                        "OTG кард-ридер",
                        "Пила дисковая",
                        "Нож для пиццы",
                        "Электробигуди",
                        "МФУ Струйное",
                        "Опрыскиватель",
                        "Электромобиль",
                        "Салазки к HDD",
                        "Стерилизатор",
                        "Газонокосилка",
                        "Онлайн-касса",
                        "Принт-сервер",
                        "Ледогенератор",
                        "Муляж камеры",
                        "Электросамовар",
                        "Масленка кухня",
                        "Рассеиватель",
                        "Звонок дверной",
                        "FM-трансмиттер",
                        "Щиток лицевой",
                        "Рамка для ТВ",
                        "Кухонные весы",
                        "Ароматизатор",
                        "Адаптеры Wi-Fi",
                        "Набор коронок",
                        "Пневмопистолет",
                        "Газовая плита",
                        "Ножи кухонные",
                        "Футляр для CD",
                        "Щипцы кухонные",
                        "Электроодеяло",
                        "Автосабвуфер",
                        "M.2 накопители",
                        "Блок розжига",
                        "Хомут, стяжки",
                        "Съемная ручка",
                        "Радиостанция",
                        "Радиоприемник",
                        "Иммобилайзер",
                        "Фотоэпилятор",
                        "Пылесос-робот",
                        "Точка доступа",
                        "Паровой шкаф",
                        "Пильная цепь",
                        "Сабельная пила",
                        "Сетевая карта",
                        "Снегоуборщик",
                        "Кресло офисное",
                        "Электропемзы",
                        "Электрокамин",
                        "Замок капота",
                        "Стереоочки 3D",
                        "Игровой набор",
                        "Электрощипцы",
                        "Электробритва",
                        "Вибронакидка",
                        "Защитный кожух",
                        "ПО Антивирус",
                        "Набор посуды",
                        "Жироанализатор",
                        "Мультистайлер",
                        "Переноска д/т",
                        "Умная розетка",
                        "Точильный круг",
                        "Блок розеток",
                        "Водяной насос",
                        "Перчатки/шапка",
                        "Микрокомпьютер",
                        "Диск для УШМ",
                        "Посуда для СВЧ",
                        "МФУ Лазерное",
                        "Пароочиститель",
                        "Газовая плитка",
                        "Пневмодолото",
                        "Помпа для Воды",
                        "Мотогарнитура",
                        "Измельчитель",
                        "Картофелемялка",
                        "Омыватель фар",
                        "Книга рецептов",
                        "Набор ключей",
                        "Электротерка",
                        "Набор кружек",
                        "Метеостанция",
                        "Швейная машина",
                        "Компрессометр",
                        "Диск пильный",
                        "Радиатор СВО",
                        "Детская посуда",
                        "Фото-вспышка",
                        "Снежный отвал",
                        "Огнетушитель",
                        "Дрель-миксер",
                        "Звуковая карта",
                        "Датчики среды",
                        "Телефон VoIP",
                        "Газоанализатор",
                        "Соковыжималка",
                        "Электродержак",
                        "Фильтр-кувшин",
                        "Термопринтер",
                        "Наушники аудио",
                        "Отрезная пила",
                        "Сауна для лица",
                        "Гайка для УШМ",
                        "Скоба, кляймер",
                        "Радиосистема",
                        "Набор отверток",
                        "Сабвуфер Hi-Fi",
                    ]
                },
            ]
        },


    ],
    currentGameState: null,
    cleanGameState: {
        currentPlayer: 0,
        winner: null,
        currentWordChunks: ['Общие'],
        selectedWord: [[], [], []],
        cleanWordsSet: [],
        currentWordsSet: [],
        usedWord: [],
        settings: {
            time: 60,
            isTeams: false,
            countForWin: 30,
            playersCount: 2,
            players: [
                {
                    title: 'Пчелы',
                    image: 0,
                    score: 0,
                    id: 45634342,
                    resolved: [],
                    unresolved: [],
                },
                {
                    title: 'Птенчики',
                    image: 1,
                    score: 0,
                    id: 959595,
                    resolved: [],
                    unresolved: [],

                },
            ],
        },
    },
    gameState: {
        currentPlayer: 0,
        winner: null,
        currentWordChunks: ['Общие'],
        selectedWord: [[], [], []],
        cleanWordsSet: [],
        currentWordsSet: [],
        usedWord: [],
        settings: {
            time: 60,
            isTeams: false,
            countForWin: 30,
            playersCount: 2,
            players: [
                {
                    title: 'Пчелы',
                    image: 0,
                    score: 0,
                    id: 45634342,
                    resolved: [],
                    unresolved: [],
                },
                {
                    title: 'Птенчики',
                    image: 1,
                    score: 0,
                    id: 959595,
                    resolved: [],
                    unresolved: [],

                },
            ],
        },
    }
}
